import { Box } from '@mantine/core'

import { useQueryGetAllItems } from '@flecto/core/store'
import { useTranslation } from '@flecto/translations'

import { CarouselItemCategories } from '../../components/CarouselItemCategories/CarouselItemCategories'
import { CarouselItems } from '../../components/CarouselItems/CarouselItems'
import { Page } from '../../components/Page/Page'
import { SectionContact } from '../../components/SectionContact/SectionContact'
import { SectionHero } from '../../components/SectionHero/SectionHero'
import { useStoreBackground } from '../../hooks/useStoreBackground'
import { useStoreCategories } from '../../hooks/useStoreCategories'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import styles from './styles.module.css'

export function PageHome() {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-home' })
  const store = useStoreDetails()
  const bg = useStoreBackground()
  const categories = useStoreCategories()

  const [category1, category2, category3, category4, category5] =
    categories ?? []

  const { data: category1Items } = useQueryGetAllItems({
    storeDomain: store?.domain,
    options: {
      q: '',
      category_ids: [category1?.id],
      limit: 20,
      offset: 0,
      enabled: Boolean(category1?.id),
    },
  })

  const { data: category2Items } = useQueryGetAllItems({
    storeDomain: store?.domain,
    options: {
      q: '',
      category_ids: [category2?.id],
      limit: 20,
      offset: 0,
      enabled: Boolean(category2?.id),
    },
  })

  const { data: category3Items } = useQueryGetAllItems({
    storeDomain: store?.domain,
    options: {
      q: '',
      category_ids: [category3?.id],
      limit: 20,
      offset: 0,
      enabled: Boolean(category3?.id),
    },
  })

  const { data: category4Items } = useQueryGetAllItems({
    storeDomain: store?.domain,
    options: {
      q: '',
      category_ids: [category4?.id],
      limit: 20,
      offset: 0,
      enabled: Boolean(category4?.id),
    },
  })

  const { data: category5Items } = useQueryGetAllItems({
    storeDomain: store?.domain,
    options: {
      q: '',
      category_ids: [category5?.id],
      limit: 20,
      offset: 0,
      enabled: Boolean(category5?.id),
    },
  })

  const image =
    bg ??
    'https://images.unsplash.com/photo-1504548840739-580b10ae7715?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'

  return (
    <Page
      className={styles.pageHome}
      htmlTitle={t('html_title', { store: store?.name })}
      htmlMetaDescription={t('html_meta_description', { store: store?.name })}
      htmlMetaOgTitle={t('html_meta_og_title', { store: store?.name })}
      htmlMetaOgDescription={t('html_meta_og_description')}
    >
      <Page.Section
        withBackgroundImage={image}
        className={styles.homeSectionHero}
      >
        <SectionHero />
      </Page.Section>
      <Page.Section className={styles.homeSectionIntro}>
        <CarouselItemCategories
          itemCategories={categories}
          title={t('carousel_categories.title')}
        />

        {category1 && (category1Items?.data?.length ?? 0) >= 3 && (
          <CarouselItems
            items={category1Items?.data}
            mt={50}
            title={t('carousel_products.title', { category: category1?.name })}
          />
        )}

        {category2 && (category2Items?.data?.length ?? 0) >= 3 && (
          <CarouselItems
            items={category2Items?.data}
            mt={50}
            title={t('carousel_products.title', { category: category2?.name })}
          />
        )}

        {category3 && (category3Items?.data?.length ?? 0) >= 3 && (
          <CarouselItems
            items={category3Items?.data}
            mt={50}
            title={t('carousel_products.title', { category: category3?.name })}
          />
        )}

        {category4 && (category4Items?.data?.length ?? 0) >= 3 && (
          <CarouselItems
            items={category4Items?.data}
            mt={50}
            title={t('carousel_products.title', { category: category4?.name })}
          />
        )}

        {category5 && (category5Items?.data?.length ?? 0) >= 3 && (
          <CarouselItems
            items={category5Items?.data}
            mt={50}
            title={t('carousel_products.title', { category: category5?.name })}
          />
        )}
      </Page.Section>
      <Page.Section withContainer={false}>
        <Box mb={-30}>
          <SectionContact />
        </Box>
      </Page.Section>
    </Page>
  )
}
